@if (easterService.isEnabled) {
    <i class="fa fa-party-horn icon left-5 top-5"></i>
    <i class="fa fa-face-party icon right-5 top-5"></i>
    <i class="fa fa-party-bell icon bottom-5 left-5"></i>
    <i class="fa fa-balloons icon bottom-5 right-5"></i>
}
